import { render, staticRenderFns } from "./FissionActivity.vue?vue&type=template&id=388d48ed&"
import script from "./FissionActivity.vue?vue&type=script&lang=ts&"
export * from "./FissionActivity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports